"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import type { NearbySuggestion } from "@/lib/session-planner/types";
import { conditionsSpotHref } from "@/lib/seo/conditions-links";

export function NearbySpotSuggestion({
  suggestion,
  sportUrlKey,
}: {
  suggestion: NearbySuggestion;
  sportUrlKey: string;
}) {
  // Canonical spot URL; the sport lens rides in the fragment.
  const href = conditionsSpotHref(suggestion.slug, sportUrlKey);
  return (
    <Link
      href={href}
      className="block rounded-[14px] border-[1.5px] border-gold/30 bg-gradient-to-br from-gold/[0.07] to-gold/[0.02] p-4 transition-colors hover:border-gold/50"
    >
      <p className="text-[13px] leading-relaxed text-text-body">{suggestion.note}</p>
      <span className="mt-2 inline-flex items-center gap-1 text-[13px] font-semibold text-navy">
        View {suggestion.name}
        <ArrowRight size={14} aria-hidden />
      </span>
    </Link>
  );
}
